import { createRouter, createWebHistory } from 'vue-router'
import Discover from '../views/Discover.vue'
import Intro from '../views/Intro.vue'  // Import Intro component
import Community from '../views/Community.vue'
import Spirits from '../views/Spirits.vue'
import Tours from '../views/Tours.vue'
import BookingConfirmation from '../views/BookingConfirmation.vue'
import ToursConfirm from '../views/ToursConfirm.vue'
import ToursConfirmed from '../views/ToursConfirmed.vue'
import Buy from '../views/Buy.vue'
import Contact from '../views/Contact.vue'
import InTheNews from '../views/InTheNews.vue'
import Article from '../views/Article.vue'
import OperatorRegister from '../views/OperatorRegister.vue'
import OperatorControl from '../views/OperatorControl.vue'
import Japan from '../views/japan.vue'
import Batch from '../views/Batch.vue'
import Team from '../views/Team.vue'
import PaymentSuccess from '../views/PaymentSuccess.vue'
import LegalDisclosure from '../views/LegalDisclosure.vue'
import CookiePolicy from '../views/CookiePolicy.vue'
import TermsAndConditions from '../views/TermsAndConditions.vue'
import InventoryManagement from '../views/InventoryManagement.vue'
import StorianReleases from '../views/StorianReleases.vue'
import EntropyIndex from '../views/EntropyIndex.vue'
import Terroir from '../views/Terroir.vue'
import RestlessEarth from '../views/RestlessEarth.vue'
import Rackhouse from '../views/Rackhouse.vue'
import Collections from '../views/Collections.vue'
import CollectionDetail from '../views/CollectionDetail.vue'
import Jobs from '../views/Jobs.vue'
import AdminLogin from '../views/admin/AdminLogin.vue'
import AdminDashboard from '../views/admin/AdminDashboard.vue'
import { useAuth } from '../composables/useAuth'

// import OperatorView from '../views/OperatorView.vue'; // Placeholder for the new component

const routes = [
  {
    path: '/product/distillery-tour/',
    redirect: { name: 'Tours' }
  },
  // Redirect broken article URLs that don't exist
  {
    path: '/saluting-quebecs-craft-the-journey-of-a-vanuatu-distillery-with-quebecois-roots-french',
    redirect: { name: 'InTheNews' }
  },
  {
    path: '/saluting-quebecs-craft-the-journey-of-a-vanuatu-distillery-with-quebecois-roots-french/',
    redirect: { name: 'InTheNews' }
  },
  {
    path: '/vanuatu-rhum-agricole',
    redirect: { name: 'InTheNews' }
  },
  {
    path: '/vanuatu-rhum-agricole/',
    redirect: { name: 'InTheNews' }
  },
  {
    path: '/',
    name: 'Intro',
    component: Intro,
    meta: {
      title: '83 Islands Distillery | Vanuatu Rum',
      description: 'Discover authentic Vanuatu rum at 83 Islands Distillery. Experience untouched, extraordinary spirits from the South Pacific. Book distillery tours and tastings.'
    }
  },
  {
    path: '/discover',
    name: 'Discover',
    component: Discover,
    meta: {
      title: 'Discover | 83 Islands Distillery'
    }
  },
  {
    path: '/entropy-index',
    name: 'Entropy Index',
    component: EntropyIndex,
    meta: {
      title: '83 Islands Entropy Index | 83 Islands Distillery',
      description: 'Discover the Entropy Index™, a world-first system measuring how nature\'s forces shape rum in Vanuatu. Experience the scientific measure of energy that moves through our spirit as it matures.'
    }
  },
  {
    path: '/terroir',
    name: 'Terroir',
    component: Terroir,
    meta: {
      title: 'Vanuatu Terroir | 83 Islands Distillery',
      description: 'Learn how Vanuatu\'s unique tropical climate influences our rum-making process and shapes the character of our spirits.'
    }
  },
  {
    path: '/restless-earth',
    name: 'Restless Earth',
    component: RestlessEarth,
    meta: {
      title: 'Restless Earth | 83 Islands Distillery',
      description: 'Discover how volcanic activity and seismic forces shape the character of our spirits in Vanuatu.'
    }
  },
  {
    path: '/spirits',
    name: 'The Spirits',
    component: Spirits,
    meta: {
      title: 'The Spirits | 83 Islands Distillery'
    }
  },
  {
    path: '/habitation-velier',
    name: 'Habitation Velier',
    component: () => import('../views/HabitationVelier.vue'),
    meta: {
      title: 'Habitation Velier 83 Islands 2021 | Oceania Pure Single Rum from Vanuatu',
      description: 'Habitation Velier 83 Islands 2021: the first Habitation Velier from Vanuatu. 100% pot still Pure Single Rum, 5 years in ex-bourbon casks, 53% barrel proof, 1,500 bottles, La Maison du Whisky exclusive.'
    }
  },
  {
    path: '/europe-shipment',
    name: 'Europe Shipment',
    component: () => import('../views/EuropeShipment.vue'),
    meta: {
      title: 'Europe Shipment | 83 Islands Distillery',
      description: 'Follow our container from Port Vila, Vanuatu to Rotterdam: estimated position, vessels and ports of call.'
    }
  },
  {
    path: '/collections',
    name: 'Collections',
    component: Collections,
    meta: {
      title: 'Collections | 83 Islands Distillery',
      description: 'Discover our exclusive collections of exceptional spirits from Vanuatu. From the Storian Collection to Single Cask expressions, explore the unique character of each range.'
    }
  },
  {
    path: '/collections/:slug',
    name: 'CollectionDetail',
    component: CollectionDetail,
    meta: {
      title: 'Collection | 83 Islands Distillery',
      description: 'Explore our exclusive collection of exceptional spirits from Vanuatu.'
    }
  },
  {
    path: '/storian-releases',
    redirect: { name: 'CollectionDetail', params: { slug: 'storian' } }
  },
  {
    path: '/rackhouse',
    name: 'Rackhouse',
    component: Rackhouse,
    meta: {
      title: 'The Rackhouse | 83 Islands Distillery',
      description: 'Explore our barrel inventory - 730 barrels aging in the tropical climate of Vanuatu, each contributing to the unique character of our spirits.'
    }
  },
  {
    path: '/rackhouse/:barrelNumber',
    name: 'RackhouseBarrel',
    component: Rackhouse,
    meta: {
      title: 'The Rackhouse | 83 Islands Distillery',
      description: 'Explore our barrel inventory - 730 barrels aging in the tropical climate of Vanuatu, each contributing to the unique character of our spirits.'
    }
  },
  {
    path: '/tours',
    name: 'Tours',
    component: Tours,
    meta: {
      title: 'Tours & Events | 83 Islands Distillery',
      description: 'Book a tour at 83 Islands Distillery. Experience our world-class rum making process and enjoy guided tastings in the best-looking bar in Port Vila.',
      step: 1,
      funnel: 'tour_booking'
    }
  },
  {
    path: '/community',
    name: 'Community',
    component: Community,
    meta: {
      title: 'Home | 83 Islands Distillery'
    }
  },
  {
    path: '/team',
    name: 'Team',
    component: Team,
    meta: {
      title: 'The Team | 83 Islands Distillery',
      description: 'Meet the passionate team behind 83 Islands Distillery. From founders to production specialists, discover the people who craft exceptional spirits with island heritage.'
    }
  },
  {
    path: '/jp',
    name: 'Japan',
    component: Japan,
    meta: {
      title: '83アイランズ蒸留所'
    }
  },
  {
    path: '/landed',
    redirect: { name: 'Intro' }
  },
  {
    path: '/japan',
    redirect: { name: 'Japan' }
  },
  {
    path: '/batch',
    name: 'Batch',
    component: Batch,
    meta: {
      title: 'Batch Information | 83 Islands Distillery'
    }
  },
  {
    path: '/batch/:pathMatch(.*)*',
    name: 'BatchWildcard',
    component: Batch,
    meta: {
      title: 'Batch Information | 83 Islands Distillery'
    }
  },
  {
    path: '/tours/booking/:tourId/:guests/:date',
    name: 'completeBooking',
    component: BookingConfirmation
  },
  {
    path: '/tours/confirm',
    name: 'toursConfirm',
    component: ToursConfirm,
    meta: {
      title: 'Confirm Tour Booking | 83 Islands Distillery',
      description: 'Complete your booking for a tour at 83 Islands Distillery. Choose your preferred time and number of guests.',
      step: 2,
      funnel: 'tour_booking'
    }
  },
  {
    path: '/tours/confirmed',
    name: 'toursConfirmed',
    component: ToursConfirmed,
    meta: {
      title: 'Booking Confirmed | 83 Islands Distillery',
      description: 'Your tour booking at 83 Islands Distillery has been confirmed. View your booking details and confirmation.',
      step: 3,
      funnel: 'tour_booking'
    }
  },
  {
    path: '/buy',
    name: 'buy',
    component: Buy
  },
  {
    path: '/contact',
    name: 'contact',
    component: Contact
  },
  {
    path: '/in-the-news',
    name: 'InTheNews',
    component: InTheNews,
    meta: {
      title: 'In the News | 83 Islands Distillery',
      description: 'Discover media coverage and press mentions about 83 Islands Distillery. Read articles from international publications about our premium rum and sustainable distilling practices.'
    }
  },
  {
    path: '/article/:id',
    name: 'Article',
    component: Article,
    meta: {
      title: 'Article | 83 Islands Distillery',
      description: 'Read the latest news and stories from 83 Islands Distillery.'
    }
  },
  {
    path: '/operator',
    name: 'OperatorRegister',
    component: OperatorRegister,
    meta: {
      title: 'Operator Program | 83 Islands Distillery'
    }
  },
  {
    path: '/operator/:companyName',
    name: 'OperatorControl',
    component: OperatorControl,
    meta: {
      title: 'Operator Dashboard | 83 Islands Distillery'
    }
  },

  {
    path: '/payment-success',
    name: 'PaymentSuccess',
    component: PaymentSuccess,
    meta: {
      title: '決済完了 | 83 Islands Distillery'
    }
  },
  {
    path: '/legal-disclosure',
    name: 'LegalDisclosure',
    component: LegalDisclosure,
    meta: {
      title: '特定商取引法等に基づく表記 | 83 Islands Distillery'
    }
  },
  {
    path: '/cookie-policy',
    name: 'CookiePolicy',
    component: CookiePolicy,
    meta: {
      title: 'Cookie Policy | 83 Islands Distillery',
      description: 'Learn how 83 Islands Distillery uses cookies and your privacy rights under GDPR.'
    }
  },
  {
    path: '/terms-and-conditions',
    name: 'TermsAndConditions',
    component: TermsAndConditions,
    meta: {
      title: 'Terms and Conditions | 83 Islands Distillery',
      description: 'Terms and conditions for using the 83 Islands Distillery website and services.'
    }
  },
  {
    path: '/jobs',
    name: 'Jobs',
    component: Jobs,
    meta: {
      title: 'Jobs | 83 Islands Distillery',
      description: 'Join the team at 83 Islands Distillery. View open positions and apply to work at Vanuatu\'s first craft rum distillery.'
    }
  },
  {
    path: '/inventory',
    name: 'InventoryManagement',
    component: InventoryManagement,
    meta: {
      title: 'Inventory Management | 83 Islands Distillery'
    }
  },
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: AdminLogin,
    meta: {
      title: 'Admin Login | 83 Islands Distillery'
    }
  },
  {
    path: '/admin/dashboard',
    name: 'AdminDashboard',
    component: AdminDashboard,
    meta: {
      title: 'Admin Dashboard | 83 Islands Distillery',
      requiresAuth: true
    }
  },
  {
    path: '/:pathMatch(.*)*',
    beforeEnter: (to, from, next) => {
      // Check if the path is an API request (handled by server, but prevent client routing)
      if (to.path.startsWith('/api/')) {
        next(false); // Abort client-side navigation
        return;
      }
      
      // Check if the path looks like a static file request 
      // (handled by server, but prevent client routing/redirect)
      if (to.path.match(/\\.(png|jpe?g|gif|svg|ico|pdf|css|js|mp4|webp|woff|woff2|ttf|eot)$/i)) {
        next(false); // Abort client-side navigation
        return;
      }
      
      // If it's not an API request or a static file, redirect to Intro
      next({ name: 'Intro' }); 
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // If the route has a hash, scroll to that element
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth'
      }
    }

    // Don't scroll when navigating between Rackhouse routes (clicking barrels)
    const rackhouseRoutes = ['Rackhouse', 'RackhouseBarrel']
    if (rackhouseRoutes.includes(to.name) && rackhouseRoutes.includes(from.name)) {
      return false // Maintain current scroll position
    }

    // Otherwise scroll to top
    return {
      top: 0,
      behavior: 'instant'
    }
  }
})

// Campaign tracking configuration
// Maps coupon codes or URL parameters to GA campaign data
const campaignMappings = {
  // Coupon-based campaigns (detected via ?coupon=xxx)
  coupons: {
    'arrivalcardjune25': {
      name: 'arrival_card_jun2025',
      source: 'print',
      medium: 'qrcode',
      content: 'arrival_card'
    },
    'arrivalcard': {
      name: 'arrival_card',
      source: 'print',
      medium: 'qrcode',
      content: 'arrival_card'
    }
    // Add more coupon mappings here as needed:
    // 'summerdeal2025': { name: 'summer_promo_2025', source: 'email', medium: 'newsletter', content: 'summer_deal' }
  },
  // Source-based campaigns (detected via ?src=xxx)
  sources: {
    'hotelcard': {
      name: 'hotel_partner',
      source: 'partner',
      medium: 'print',
      content: 'hotel_card'
    },
    'cruiseship': {
      name: 'cruise_ship_promo',
      source: 'cruise',
      medium: 'print',
      content: 'cruise_flyer'
    }
    // Add more source mappings here
  }
}

// Track campaign in GA4 without modifying URL
const trackCampaign = (campaign) => {
  if (window.gtag && campaign) {
    // Set campaign parameters for this session
    gtag('set', {
      'campaign_name': campaign.name,
      'campaign_source': campaign.source,
      'campaign_medium': campaign.medium,
      'campaign_content': campaign.content || undefined
    })

    // Fire a custom event for easier tracking
    gtag('event', 'campaign_detected', {
      campaign_name: campaign.name,
      campaign_source: campaign.source,
      campaign_medium: campaign.medium,
      campaign_content: campaign.content || ''
    })

    console.log('[GA] Campaign tracked:', campaign.name)
  }
}

// Enhanced title and meta update logic
router.beforeEach(async (to, from, next) => {
  // Detect and track campaigns from URL parameters
  const couponCode = to.query.coupon?.toLowerCase()
  const sourceCode = to.query.src?.toLowerCase()

  if (couponCode && campaignMappings.coupons[couponCode]) {
    trackCampaign(campaignMappings.coupons[couponCode])
  } else if (sourceCode && campaignMappings.sources[sourceCode]) {
    trackCampaign(campaignMappings.sources[sourceCode])
  }

  // Check authentication for protected routes
  if (to.meta.requiresAuth) {
    const { isAuthenticated, verifyToken } = useAuth()

    if (!isAuthenticated.value) {
      // Not authenticated, redirect to login
      next({ name: 'AdminLogin' })
      return
    }

    // Verify token is still valid
    const valid = await verifyToken()
    if (!valid) {
      // Token expired, redirect to login
      next({ name: 'AdminLogin' })
      return
    }
  }

  // Update title
  document.title = to.meta.title || '83 Islands Distillery | Vanuatu Rum'
  
  // Update meta description
  let descriptionMeta = document.querySelector('meta[name="description"]')
  if (!descriptionMeta) {
    descriptionMeta = document.createElement('meta')
    descriptionMeta.name = 'description'
    document.head.appendChild(descriptionMeta)
  }
  descriptionMeta.content = to.meta.description || 'Discover authentic Vanuatu rum at 83 Islands Distillery. Experience untouched, extraordinary spirits from the South Pacific.'

  // Update canonical URL (normalize without trailing slash, except for root)
  const canonicalLink = document.getElementById('canonical-url')
  if (canonicalLink) {
    let canonicalPath = to.path
    // Remove trailing slash except for homepage
    if (canonicalPath !== '/' && canonicalPath.endsWith('/')) {
      canonicalPath = canonicalPath.slice(0, -1)
    }
    canonicalLink.setAttribute('href', `https://83islands.com${canonicalPath}`)
  }

  // Track page view and funnel step if applicable
  if (window.gtag) {
    gtag('event', 'page_view', {
      page_title: to.meta.title,
      page_path: to.fullPath,
      page_location: window.location.href
    })

    // Track funnel step if present
    if (to.meta.funnel && to.meta.step) {
      gtag('event', 'tour_booking_step', {
        funnel: to.meta.funnel,
        step: to.meta.step,
        step_name: to.name
      })
    }

    // Add these to your existing GA4 configuration
    gtag('config', 'G-RMV17CXZRM', {
      custom_map: {
        'dimension1': 'tour_type',
        'dimension2': 'time_slot',
        'dimension3': 'booking_status',
        'dimension4': 'preferred_language'
      }
    });
  }

  next()
})

export default router